import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Community Calls | Edgeryders',
        metaTags: [
          {
            name: 'description',
            content: 'Inspire and connect with others all over Europe by sharing your story.'
          },
          {
            property: 'og:description',
            content: 'Inspire and connect with others all over Europe by sharing your story.'
          }
        ]
      }
    },
    {
      path: '/:id',
      name: 'home',
      component: Home,
    }
  ]
})
